import Model, { attr, hasMany } from '@ember-data/model';

export default class TreeItemBulkSave extends Model {
  @hasMany('station', { inverse: null, async: false, embedded: true, noCascade: true }) stations;
  @hasMany('task', { inverse: null, async: false, embedded: true, noCascade: true }) tasks;
  @hasMany('task-config', { inverse: null, async: false, embedded: true, noCascade: true }) taskConfigs;

  @attr('string') source;
}
